// extracted by mini-css-extract-plugin
export default {"pdfMobilePreview":"FormatChecker_pdfMobilePreview__AWX17","pdfDesktopPreview":"FormatChecker_pdfDesktopPreview__6WbWo"};